export default __webpack_public_path__ + "static/media/desktopBg.37277240.png";